import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Body, PageHeader, AddButton } from '@components';
import TableTarefas from './TableTarefas';

import App from '@app';

export default function Configuracoes() {
  const history = useHistory();
  const { idConfiguracao, idFonteDado } = useParams();

  return (
    <App>
      <Body>
        <PageHeader
          title="Tarefas"
          onBack={() => history.goBack()}
          extra={[
            <AddButton
              key="1"
              type="primary"
              tooltipTitle="Adicionar Tarefa"
              style={{ marginBottom: 10 + 'px', borderRadius: 5 + 'px' }}
              onClick={() => history.push(`/conectores/configuracao/${idConfiguracao}/fonte/dado/${idFonteDado}/tarefa/-1`)}
            />,
          ]}
        >
          <TableTarefas />
        </PageHeader>
      </Body>
    </App>
  );
}
